import React from 'react';
import { b as _objectWithoutProperties, c as _extends } from './_rollupPluginBabelHelpers-b9ad31fa-7ae21c08.js';
import { u as useActivify } from './withTooltip-92e0dfed.js';

var _excluded = ["active"];
var Activify = function Activify() {
  return function (WrappedComponent) {
    // eslint-disable-next-line react/prop-types
    return function (_ref) {
      var active = _ref.active,
        props = _objectWithoutProperties(_ref, _excluded);
      var _useActivify = useActivify(active),
        visible = _useActivify.visible,
        enabled = _useActivify.enabled;
      if (!enabled) return null;
      // eslint-disable-next-line react/jsx-props-no-spreading
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
        active: visible
      }));
    };
  };
};

export { Activify as A };
